import {ObjectUtils} from "../data/ObjectUtils";
import {DropDownInput, IDropDownInputConfig} from "./DropDownInput";

export interface IColorOption
{
	label: string;
	hex: string;
}

export class ColorSelectInput extends DropDownInput<IColorOption>
{
	constructor(config)
	{
		/* the color selector list has to start with the default color */
		config.values.forEach(function(item, index, object) {
			if(item.hex === config.value){
				object.splice(0, 0, item);
				object.splice(index+1, 1);
			}
		});

		const defaultConfig: IDropDownInputConfig<IColorOption> = {
			tpl: {
				element: document.getElementById("color-element").textContent,
				button: document.getElementById("color-button").textContent,
				list: document.getElementById("color-list").textContent,
				disclaimer: document.getElementById("color-disclaimer").textContent,
				option: document.getElementById("color-option").textContent
			},
			values: config.values,
			value: config.value,
			idProperty: "hex"
		};

		config = ObjectUtils.mergeConfig(defaultConfig, config);

		super(config);
	}

	public override dispatchChange(event: Event)
	{
		var hex = this._value[this._values.keyProperty];
		this.changeSignal.dispatch(hex, this, event);
	}

	/*
	public get color()
	{
		var hex = this._value[this._values.keyProperty];
		var hexString = hex.substr(1);
		var color = parseInt(hexString, 16);

		return color;
	}
	*/
}
